<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(clickAdd)">
        <!-- 語言 -->
        <div class="form-row">
          <div class="form-group col-md-12">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <select class="form-control w-100" v-model="foreignValue">
                <option :value="null" disabled>
                  {{ i18n("Language.SelectLanguage") }}
                </option>
                <option
                  v-for="item in foreignList"
                  :key="item.Guid"
                  :value="item"
                >
                  {{ item.Name }}
                </option>
              </select>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>

          <div v-if="otherLanguage" class="form-group col-md-12">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <input
                type="text"
                class="form-control"
                maxlength="200"
                placeholder="請填寫外語名稱"
                v-model.trim="foreign.LanguageDescription"
              />
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>

          <!-- 聽 -->
          <div class="form-group col-md">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <label for="" class="col-form-label" style="margin-right: 5px">
                {{ i18n("Language.Listen") }}
              </label>
              <select
                class="form-control"
                v-model="foreign.Listen"
                style="flex: 1; min-width: 1px"
              >
                <option :value="null" disabled>
                  {{ i18n("Basic.Select") }}
                </option>
                <option
                  v-for="item in degreeList"
                  :key="item.Guid"
                  :value="item"
                >
                  {{ item.Name }}
                </option>
              </select>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>

          <!-- 說 -->
          <div class="form-group col-md">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <label for="" class="col-form-label" style="margin-right: 5px">
                {{ i18n("Language.Speak") }}
              </label>
              <select
                class="form-control"
                v-model="foreign.Speak"
                style="flex: 1; min-width: 1px"
              >
                <option :value="null" disabled>
                  {{ i18n("Basic.Select") }}
                </option>
                <option
                  v-for="item in degreeList"
                  :key="item.Guid"
                  :value="item"
                >
                  {{ item.Name }}
                </option>
              </select>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>

          <!-- 讀 -->
          <div class="form-group col-md">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <label for="" class="col-form-label" style="margin-right: 5px">
                {{ i18n("Language.Read") }}
              </label>
              <select
                class="form-control"
                v-model="foreign.Read"
                style="flex: 1; min-width: 1px"
              >
                <option :value="null" disabled>
                  {{ i18n("Basic.Select") }}
                </option>
                <option
                  v-for="item in degreeList"
                  :key="item.Guid"
                  :value="item"
                >
                  {{ item.Name }}
                </option>
              </select>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>

          <!-- 寫 -->
          <div class="form-group col-md">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <label for="" class="col-form-label" style="margin-right: 5px">
                {{ i18n("Language.Write") }}
              </label>
              <select
                class="form-control"
                v-model="foreign.Write"
                style="flex: 1; min-width: 1px"
              >
                <option :value="null" disabled>
                  {{ i18n("Basic.Select") }}
                </option>
                <option
                  v-for="item in degreeList"
                  :key="item.Guid"
                  :value="item"
                >
                  {{ item.Name }}
                </option>
              </select>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="form-row">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            style="margin-left: 6px; margin-right: 10px"
            @click="clickCancel"
          >
            {{ i18n("Buttons.Cancel") }}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">
            {{ i18n("Buttons.Save") }}
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  name: "AddLanguage",

  props: ["disabled"],
  data() {
    return {
      type: "Language",

      foreignList: [],
      foreignValue: null,
      otherLanguage: false,

      // 程度
      degreeList: [],

      foreign: {
        LanguageGuid: null,
        Language: null,
        LanguageDescription: null,
        ListenGuid: null,
        Listen: null,
        SpeakGuid: null,
        Speak: null,
        ReadGuid: null,
        Read: null,
        WriteGuid: null,
        Write: null,
      },
    };
  },
  methods: {
    clickCancel() {
      this.$emit("addCancel");
    },
    clickAdd() {
      // 聽
      this.foreign.ListenGuid = this.foreign.Listen.Guid;
      this.foreign.Listen = this.foreign.Listen.Name;
      // 說
      this.foreign.SpeakGuid = this.foreign.Speak.Guid;
      this.foreign.Speak = this.foreign.Speak.Name;
      // 讀
      this.foreign.ReadGuid = this.foreign.Read.Guid;
      this.foreign.Read = this.foreign.Read.Name;
      // 寫
      this.foreign.WriteGuid = this.foreign.Write.Guid;
      this.foreign.Write = this.foreign.Write.Name;
      this.$emit("addLanguage", this.foreign, this.type);
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },
  watch: {
    foreignValue: function (newVal) {
      if (newVal.Code === "other") {
        this.otherLanguage = true;
      } else {
        this.otherLanguage = false;
        this.foreign.LanguageDescription = null;
      }
      if (typeof newVal === "object") {
        this.foreign.LanguageGuid = newVal.Guid;
        this.foreign.Language = newVal.Name;
      }
    },
  },

  created() {
    // 取得外語
    this.get_foreign_language().then((result) => {
      this.foreignList = result;
    });
    // 取得程度
    this.get_language_degree().then((result) => {
      this.degreeList = result;
    });
  },
};
</script>

<style scoped lang="scss">
.btn-primary {
  &:disabled {
    background-color: #eee;
    border-color: #eee;
    color: black;
    cursor: auto;
  }
}
</style>
